import * as types from './mutation_types';
import Vue from 'vue';

export const setInstRecid = ({ state, commit, dispatch }, {vm, instanceRecid, templateRecid, channelRecid, userRole}) => {
   if (state.instanceRecid > 0) {
      //instance is open, need to reset smart canvas
      dispatch('resetSmartCanvas', {vm}).then(() => {
         commit(types.SET_INST_RECID, 
            {
               instanceRecid, 
               templateRecid, 
               channelRecid, 
               userRole
            }
         );
      });
   } else {
      commit(types.SET_INST_RECID,
         {
            instanceRecid, 
            templateRecid, 
            channelRecid, 
            userRole
         }
      );
   }
}

export const resetSmartCanvas = ({ commit, state }, {vm}) => {
   if (state.instanceRecid > 0) {
      const request = new Promise((resolve, reject) => {
         $.post(
            vm.BARD_HOST + '/instance/unlock/' + state.instanceRecid,
            {
               'token'        : localStorage.getItem('token')
            }, function(data) {
               if (!data.error) {
                  resolve(data);
               } else {
                  reject(data);
               }
            }
         );
      });

      return request
         .then(( data ) => {
            commit(types.RESET_SMART_CANVAS);
         })
         .catch(( data ) => {
         }); 
   }
}

//Get instances
export const requestInstanceData = ({ commit }) => commit(types.REQUEST_INSTANCE_DATA);
export const receiveInstanceDataError = ({ state, commit, dispatch }, data) => {
   if (data.already_locked) {
      commit(types.INSTANCE_LOCKED, data.user);
      if (state.userRole == 100) {
         commit(types.ADMIN_UNLOCK_MODAL, 
            {
               user: data.user,
               instanceRecid: state.instanceRecid,
               channelRecid: state.channelRecid
            }
         );
      } else {
         //build the error modal
         // let modalData = {};
         // modalData.modalError = true;
         // modalData.modalSubheadText = 'This Instance cannot be opened.';
         // if (data.already_locked) {
         //    modalData.modalMessage = data.user + ' is currently editing this Instance.';
         // } 
         // dispatch('global/displayModal', {modalData}, {root:true});
      }
   }
};
export const receiveInstanceDataSuccess = ({ state, commit }, data) => {
   commit(types.RECEIVE_INSTANCE_DATA_SUCCESS, data);
   if (data.already_locked) {
      commit(types.INSTANCE_LOCKED, data.user);
      if (state.userRole == 100) {
         commit(types.ADMIN_UNLOCK_MODAL, 
            {
               user: data.user,
               instanceRecid: state.instanceRecid,
               channelRecid: state.channelRecid
            }
         );
         dispatch('global/displayModal', {modalData}, {root:true});
      }
   }
}
  

export const fetchInstanceData = (
      { state, dispatch },
      { vm }
   ) => {
      // dispatch('resetSmartCanvas');
      dispatch('requestInstanceData');

      // const lockRequest = new Promise((resolve, reject) => {
      //    $.post(
      //       vm.BARD_HOST + '/instance/lock/' + state.instanceRecid,
      //       {
      //          'token'        : localStorage.getItem('token')
      //       }, function(data) {
      //          if (!data.error) {
      //             resolve(data);
      //          } else {
      //             reject(data);
      //          }
      //       }
      //    );
      // });

      const request = new Promise((resolve, reject) => {
         $.post(
            vm.BARD_HOST + '/instance/list/' + state.instanceRecid,
            {
               'token'      : localStorage.getItem('token'),
            },
            function(data) {
               if (!data.error) {
                  resolve(data);
               } else {
                  reject(data);
               }
            }
         ).catch((e) => {
            console.log(e.responseText);
         });
      })
    
      // return lockRequest
      //   .then(( data ) => {
      //       return new Promise((resolve, reject) => {
      //          $.post(
      //             vm.BARD_HOST + '/instance/list/' + state.instanceRecid,
      //             {
      //                'token'      : localStorage.getItem('token'),
      //             },
      //             function(data) {
      //                if (!data.error) {
      //                   resolve(data);
      //                } else {
      //                   reject(data);
      //                }
      //             }
      //          );
      //       });
      //   })
      return request
        .then((data) => {
            dispatch('receiveInstanceDataSuccess', data);
        }) 
        .catch(( data ) => {
            if (vm.isAPILoginError(data)) {
               dispatch('global/handleAPILoginError', data, {root:true});
            } else {
               dispatch('receiveInstanceDataError', data);
            }
        });
}

export const changeTitle = (
   { commit, dispatch },
   { title }
) => {
   commit(types.CHANGE_TITLE, title);
   dispatch('editsMade');
}

export const changeScene = (
   { state, commit },
   { scene }
) => {
   scene = "scene" + scene;
   commit(types.CHANGE_SCENE, scene);
}

export const changeZoneText = (
   { commit, dispatch },
   { zoneId, text }
) => {
   commit(types.CHANGE_ZONE_TEXT, {zoneId, text});
   dispatch('editsMade');
}

export const changeZoneColor = (
   { commit, dispatch },
   { color }
) => {
   commit(types.CHANGE_ZONE_COLOR, color);
   dispatch('editsMade');
}

export const setActiveZone = (
   { commit },
   { zone }
) => {
   commit(types.SET_ACTIVE_ZONE, zone);
}

export const removeAsset = (
   { commit, dispatch },
   { zone }
) => {
   commit(types.REMOVE_ASSET, zone);
   dispatch('editsMade');
}

export const assignAsset = (
   { state, dispatch, commit },
   { vm, asset }
) => {


   if (state.activeZone) {
      commit(types.IS_ASSIGNING_ASSET);
      commit(types.UPDATE_ZONE_ASSET_DICT, asset);

      if (asset.c_asset_type == 6) { //if feed, we need to get the feed's slots
         const request = new Promise((resolve, reject) => {
            $.post(
               vm.BARD_HOST + '/feeds/slots/' + asset.c_origin_fk,
               {
                  'token'      : localStorage.getItem('token')
               },
               function(data) {
                  if (!data.error) {
                     resolve(data);
                  } else {
                     reject(data);
                  }
               }
            );
         });

         return request
            .then(( data ) => {
               let filenames = [];
               let thumbs = [];
               let titles = [];
               for (let file of data) {
                  filenames.push(file.c_filename);
                  thumbs.push(file.c_thumbnail);
                  titles.push(file.c_desc1);
               }
               commit(types.ASSIGN_ASSET, {asset, val: filenames, title: titles, thumb: thumbs});
               dispatch('editsMade');
            })
            .catch(( data ) => {
               if (vm.isAPILoginError(data)) {
                  dispatch('global/handleAPILoginError', data, {root:true});
               } 
            });
      } else {
         commit(types.ASSIGN_ASSET, {asset, val: asset.c_filename, title: asset.c_desc1, thumb: asset.c_uri});
         dispatch('editsMade');
      }

   } else {
      console.log('Active Zone is undefined');
   }
}


//Saving
export const requestSaveInstance = ({ commit }) => commit(types.REQUEST_SAVE_INSTANCE);
export const receiveSaveInstanceError = ({ commit, dispatch }, {data, status}) => {
    //build the error modal
   //  let modalData = {};
   //  modalData.modalError = true;
   //  modalData.modalSubheadText = 'This Instance could not be saved.';
   //  if (data.message == 'Duplicate title') {
   //    modalData.modalMessage = 'There is already an instance with this title. Please enter a unique title.';
   //    modalData.action = true;
   //    modalData.actionType = 'input';
   //  } else if (data.message == 'zones') {
   //    modalData.modalMessage = 'There are required zones that you have not assigned media to.';
   //    modalData.modalList = data.list;
   //  } else if (data.message == 'Locked out of instance') {
   //    modalData.modalMessage = 'You\'ve been locked out of the Instance by an Admin user';
   //  }
   //  dispatch('global/displayModal', {modalData}, {root:true});
   let message = '';
   let modalList = null;
   if (data.message == 'Duplicate title') {
      message = 'There is already an instance with this title. Please enter a unique title.';
      commit(types.UNIQUE_TITLE_ERROR);
   } else if (data.message == 'zones') {
      message = 'There are required zones that you have not assigned media to.';
      modalList = data.list;
   } else if (data.message == 'Locked out of instance') {
      message = 'You\'ve been locked out of the Instance by an Admin user';
   }

   dispatch(
      'setErrorMessage',
      {
         subheadText: 'This Instance could not be saved',
         messageText: message,
         list: modalList
      },
      { root: true }
   );

   commit(types.RECEIVE_SAVE_INSTANCE_ERROR, {error: 'title', status});
};
export const receiveSaveInstanceSuccess = ({ commit }, data) =>
  commit(types.RECEIVE_SAVE_INSTANCE_SUCCESS, data);

export const saveInstance = (
   { state, dispatch },
   { vm, status }
) => {
   dispatch('requestSaveInstance');

   //check to make sure all required zones have been filled
   if (status == 1) {
      let emptyZones = [];
      state.instanceJson.tmpl.assets.forEach(zone => {
         if (zone.val === '' && zone.required && !zone.replace) {
            let zoneStr = 'Zone ' + (zone.id/1000);
            emptyZones.push(zoneStr);
         }
      });

      state.instanceJson.tmpl.data.text.forEach(zone => {
         if (zone.val === '' && zone.required) {
            let zoneStr = 'Zone ' + (zone.id/1000);
            emptyZones.push(zoneStr);
         }
      });

      if (emptyZones.length > 0) {
         let data = {};
         data.message = 'zones';
         data.list = emptyZones;
         dispatch('receiveSaveInstanceError', {data});
         return;
      }
   }

   const request = new Promise((resolve, reject) => {
      $.post(
         vm.BARD_HOST + '/instance/update/' + state.instanceRecid,
         {
            'token'      : localStorage.getItem('token'),
            'json': JSON.stringify(state.instanceJson),
            'title': state.instanceTitle,
            'thumb': state.thumbnail,
            'status': status,
            'duration': state.duration,
            'assets': JSON.stringify(Object.values(state.zoneToAssetsDict)),
            'channelRecids': state.channels.toString()
         },
         function(data) {
            if (!data.error) {
               resolve(data);
            } else {
               reject(data);
            }
         }
      ).fail((e) => {
         console.log(e.responseText);
      }); 
   });

   return request
      .then(( data ) => {
         $.post(
            vm.BARD_HOST + '/dist/instance',
            {
               'token' : localStorage.getItem('token'),
               'recid' : state.instanceRecid,
            },
            function(data) {
               if (data.error) {
                  console.log("Failed to send /dist call for instance save");
               }
            }
         );
			// KML - 2020-03-06 - added in pass through of instance status value
			//                    to force Save As to appear after initial Save
			data.instanceStatus = status;
			// END KML
         dispatch('receiveSaveInstanceSuccess', data);
      })
      .catch(( data ) => {
         if (vm.isAPILoginError(data)) {
            dispatch('global/handleAPILoginError', data, {root:true});
         } else {
            dispatch('receiveSaveInstanceError', {data, status});
         }
      }); 
}

//Save As
export const requestSaveAsInstance = ({ commit }) => commit(types.REQUEST_SAVE_AS_INSTANCE);
export const receiveSaveAsInstanceError = ({ commit, dispatch }, {data, status}) => {
    //build the error modal
    let modalData = {};
    modalData.modalError = true;
    modalData.modalSubheadText = 'This Instance could not be saved.';
    if (data.message == 'Duplicate title') {
      modalData.modalMessage = 'There is already an instance with this title. Please enter a unique title.';
      modalData.action = true;
      modalData.actionType = 'input';
    } else if (data.message == 'zones') {
      modalData.modalMessage = 'There are required zones that you have not assigned media to.';
      modalData.modalList = data.list;
    }
    dispatch('global/displayModal', {modalData}, {root:true});
    commit(types.RECEIVE_SAVE_AS_INSTANCE_ERROR, {error: 'title'});
};

export const receiveSaveAsInstanceSuccess = ({ commit }, data) =>
  commit(types.RECEIVE_SAVE_AS_INSTANCE_SUCCESS, data);

export const saveAsInstance = (
   { state, commit, dispatch },
   { vm, title }
) => {
   dispatch('requestSaveAsInstance');

   const request = new Promise((resolve, reject) => {
      $.post(
         vm.BARD_HOST + '/instance/saveas',
         {
            'token'      : localStorage.getItem('token'),
            'json': JSON.stringify(state.instanceJson),
            'recid' : state.instanceRecid,
            'title': title,
            'thumb': state.thumbnail,
            'status': 1,
            'assets': JSON.stringify(Object.values(state.zoneToAssetsDict)),
            'channelRecids': 9 //TODO: update
         },
         function(data) {
            if (!data.error) {
               resolve(data);
            } else {
               reject(data);
            }
         }
      ).fail((e) => {
         console.log(e.responseText);
      }); 
   });

   return request
      .then(( data ) => {
         dispatch('receiveSaveAsInstanceSuccess', data);
         // dispatch('setInstRecid', {instanceRecid: data.recid, templateRecid: state.templateRecid});
      })
      .catch(( data ) => {
         if (vm.isAPILoginError(data)) {
            dispatch('global/handleAPILoginError', data, {root:true});
         } else {
            dispatch('receiveSaveAsInstanceError', {data, status});
         }
      }); 
}

export const handleModalResponse = (
   { state, commit, dispatch },
   { vm, data }
) => {
   dispatch('global/closeModal', {root:true});
   if (state.duplicateTitleErrorState && state.saveAsState) {
      dispatch('saveAsInstance', {vm, title: data});
   } else if (state.duplicateTitleErrorState) {
      dispatch('changeTitle', {title: data});
      dispatch('saveInstance', {vm, status: state.attemptedStatusSave});
   } else if (state.saveAsState) {
      dispatch('saveAsInstance', {vm, title: data});
   }
}

export const displaySaveAsModal = (
   { state, commit, dispatch }
) => {
   let modalData = {};
   modalData.modalError = false;
   modalData.modalSubheadText = 'Save As';
   modalData.modalMessage = 'Enter a title for the new instance.';
   modalData.action = true;
   modalData.actionType = 'input';
   dispatch('global/displayModal', {modalData}, {root:true});
   commit(types.SAVE_AS_STATE, true);
}

//Hide/Show Zones
export const toggleHideZone = (
   { state, commit },
   { hide, zoneId }
) => {
   commit(types.TOGGLE_HIDE_ZONE, {hide, zoneId});
}

export const toggleAllZones = (
   { state, commit }
) => {
   commit(types.TOGGLE_ALL_ZONES);
}



/* Toolbox Actions */

export const toggleMediaPicker = (
   { commit, dispatch },
) => {
   dispatch('global/toggleMediaPicker', null, {root: true});
}

export const scaleImage = (
   { commit, dispatch },
   { direction }
) => {
   commit(types.SCALE_IMAGE, direction);
   dispatch('editsMade');
}

export const rotateImage = (
   { commit, dispatch },
   { direction }
) => {
   commit(types.ROTATE_IMAGE, direction);
   dispatch('editsMade');

}

export const flipImage = (
   { commit, dispatch },
   { direction }
) => {
   commit(types.FLIP_IMAGE, direction);
   dispatch('editsMade');

}

export const toggleMoveImage = (
   { commit }
) => {
   commit(types.TOGGLE_MOVE_IMAGE);
}

export const toggleColorPicker = (
   { commit },
) => {
   commit(types.TOGGLE_COLOR_PICKER);
}

export const triggerPreview = (
   { commit }
) => {
   commit(types.PREVIEW_INSTANCE);
}

export const closePreview = (
   { commit }
) => {
   commit(types.CLOSE_PREVIEW);
}

export const editsMade = (
   { commit }
) => {
   commit(types.EDITS_MADE);
}

export const handleUnsavedChanges = (
   { commit, dispatch }
) => {
   let modalData = {};
   modalData.modalError = true;
   modalData.modalSubheadText = 'You have unsaved changes.';
   modalData.modalMessage = 'If you navigate away, these changes will be lost.';
   modalData.action = true;
   modalData.actionType = 'input';
   dispatch('global/displayModal', {modalData}, {root:true});
   commit(types.UNSAVED_NAVIGATION_STATE, true);
}

export const breakLock = (
   { state, dispatch, commit },
   { user, vm }
) => {
   const request = new Promise((resolve, reject) => {
      $.post(
         vm.BARD_HOST + '/instance/break_lock/' + state.attemptedOpenInstanceRecid,
         {
            'token'        : localStorage.getItem('token')
         }, function(data) {
            if (!data.error) {
               resolve(data);
            } else {
               reject(data);
            }
         }
      );
   });

   return request
      .then(( data ) => {
         commit(types.INSTANCE_UNLOCKED);
         dispatch('closeUnlockModal');
         // dispatch('setInstRecid', 
         //    {
         //       instanceRecid: state.attemptedOpenInstanceRecid,
         //       channelRecid: state.channelRecid,
         //       templateRecid: state.templateRecid,
         //       userRole: state.userRole
         //    }
         // );
         dispatch('fetchInstanceData', {vm});
      })
      .catch((data) => {
         if (vm.isAPILoginError(data)) {
               dispatch('global/handleAPILoginError', data, {root:true});
         } 
      });
}

export const unlockInstance = (
   {state, dispatch, commit},
   { user, vm }
) => {
   const request = new Promise((resolve, reject) => {
      $.post(
         vm.BARD_HOST + '/instance/unlock/' + state.instanceRecid,
         {
            'token'        : localStorage.getItem('token')
         }, function(data) {
            if (!data.error) {
               resolve(data);
            } else {
               reject(data);
            }
         }
      );
   });

   return request
      .then(( data ) => {
      })
      .catch((data) => {
         console.log("Error unlocking Instance");
         console.log(data);
      });
}

export const closeUnlockModal = (
   { commit }
) => {
   commit(types.CLOSE_UNLOCK_MODAL);
}


export const setErrorMessage = ({ state, commit }, message) => {
   if (!state.errorMessage) { //only want one error message at time 
      commit(types.SET_ERROR_MESSAGE, message);
   }
}

export const closeModal = (
   { commit }
) => {
   commit(types.CLOSE_MODAL);
}


export default () => {};

